module.exports = __webpack_public_path__ + "static/media/IMG_0107.4021d654.jpg";